import React from 'react';
import Markdown from "react-markdown";
import remarkGfm from 'remark-gfm'

const ArticleContent = ({content, embeddedImages}) => {
  return (
    <article className="prose prose-invert max-w-none">
      <Markdown remarkPlugins={[remarkGfm]}>
        {content}
      </Markdown>
    </article>
  );
};

export default ArticleContent;